/* eslint-disable @typescript-eslint/no-explicit-any */
import { capitalize } from 'es-toolkit/compat';
import keyMirror from 'keymirror';

const TicketGroupStateConstants = keyMirror({
  AVAILABLE: null,
  HELD: null,
  SOLD: null,
  LOCKED: null,
}) as any;

TicketGroupStateConstants.purchaseStateName = (key: any) => {
  switch (key) {
    case TicketGroupStateConstants.AVAILABLE:
      return 'Available';
    case TicketGroupStateConstants.SOLD:
      return 'Booked';
    case TicketGroupStateConstants.HELD:
      return 'Held';
    case TicketGroupStateConstants.LOCKED:
      return 'Pending';
    case 'NO_SHOWS':
      return 'No-shows';
    case 'SHORT_SEATED':
      return 'Short-seated';
    case 'WALK_INS':
      return 'Walk-ins';
    default:
      return capitalize(key.toLowerCase());
  }
};

export default TicketGroupStateConstants;
